import React, { useState, useEffect } from "react";
import RoomBookingCard from "./RoomBookingCard";
import { DRAWER_BACKGROUND } from "../../../constants/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export default function RoomBookingsDetailDrawer(props) {

    const {
        open,
        bookings,
		daySummaries
    } = props;

    const [selectedDate, setSelectedDate] =
        useState(null);


    const [filteredBookings, setFilteredBookings] =
        useState([]);

    // --------------------------------------------------------
    // BUILD DAY SUMMARIES
    // --------------------------------------------------------

    useEffect(function () {

        if (!bookings || bookings.length === 0) {

            //setDaySummaries([]);
            setFilteredBookings([]);

            return;
        }

        const summaryMap = {};

        bookings.forEach(function (booking) {

            if (!booking.bookingDate) {
                return;
            }

            var bookingDate =
                String(booking.bookingDate);

            if (!summaryMap[bookingDate]) {

                const date =
                    new Date(bookingDate);

                summaryMap[bookingDate] = {

                    bookingDate: bookingDate,

                    bookingCount: 0,

                    dayLabel:
                        date.toLocaleDateString(
                            "en-GB",
                            {
                                weekday: "short"
                            }
                        ).toUpperCase(),

                    prettyDate:
                        date.toLocaleDateString(
                            "en-GB",
                            {
                                day: "numeric",
                                month: "short"
                            }
                        )
                };
            }

            summaryMap[bookingDate].bookingCount++;
        });

        const summaries =
            Object.values(summaryMap);

        summaries.sort(function (a, b) {

            return (
                new Date(a.bookingDate)
                -
                new Date(b.bookingDate)
            );
        });

        //setDaySummaries(summaries);

        if (summaries.length > 0) {

            setSelectedDate(
                summaries[0].bookingDate
            );
        }

    }, [bookings]);

    // --------------------------------------------------------
    // FILTER BOOKINGS
    // --------------------------------------------------------

    useEffect(function () {

        if (!selectedDate) {
            return;
        }

        const filtered =
            bookings.filter(function (booking) {

                return (
                    String(booking.bookingDate)
                    ===
                    String(selectedDate)
                );
            });

        setFilteredBookings(filtered);

    }, [selectedDate, bookings]);

    // --------------------------------------------------------
    // STYLES
    // --------------------------------------------------------

    const closeCircle = {

        position: "absolute",
        left: "-18px",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 3,

        width: "36px",
        height: "36px",

        borderRadius: "50%",

        background: "#f4f6f8",
        color: "#666",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        cursor: "pointer",

        fontSize: "14px",

        boxShadow:
            "0 4px 12px rgba(0,0,0,0.1)",

        border:
            "1px solid rgba(255,255,255,0.08)",

        transition: "all 0.2s ease"
    };

    // --------------------------------------------------------
    // RENDER
    // --------------------------------------------------------

    return (

        <div

            onClick={function (e) {
                e.stopPropagation();
            }}

            style={{

                position: "fixed",

                top: "60px",

                right: "450px",

                transform:
                    open
                        ? "translateX(0px)"
                        : "translateX(calc(100vw + 200px))",

                width: "calc(100vw - 850px)",

                height: "100vh",

                background:
               //     DRAWER_BACKGROUND,
			   '#f4f6f8',

                backdropFilter: "blur(12px)",

                WebkitBackdropFilter:
                    "blur(12px)",

                borderLeft:
                    "1px solid rgba(255,255,255,0.08)",

                boxShadow:
                    "-30px 0 60px rgba(0,0,0,0.75)",

                transition:
                    "transform 0.45s cubic-bezier(0.4, 0, 0.2, 1)",

                zIndex: 999,

                display: "flex",

                flexDirection: "column",

                //overflow: "hidden"
            }}
        >

            {/* ------------------------------------------------ */}
            {/* HEADER */}
            {/* ------------------------------------------------ */}

            <div
                style={{
                    padding: "18px 22px 14px 22px",
                    borderBottom:
                        "1px solid rgba(255,255,255,0.08)",
                    flexShrink: 0
                }}
            >

                <div
                    style={{
                        fontSize: "22px",
                        fontWeight: "700",
                        color: "#666",
                        marginBottom: "14px",
                        letterSpacing: "1px"
                    }}
                >
                    ROOM BOOKINGS
                </div>

                {/* ------------------------------------------------ */}
                {/* DAY BOXES */}
                {/* ------------------------------------------------ */}

                <div
                    style={{

                        display: "grid",

                        gridTemplateColumns:
                            "repeat(auto-fit,minmax(94px,1fr))",

                        gap: "10px"
                    }}
                >

				{daySummaries.map(function (day) {
					console.log('Day');
					console.log(day);
				    const selected =
				        selectedDate === day.bookingDate;

				    return (
				        <div
				            key={day.bookingDate}
				            onClick={function () {
				                setSelectedDate(day.bookingDate);
				            }}
				            style={{
				                height: "58px",
				                borderRadius: "10px",
				                background: selected ? "#5a9bd6" : "#ffffff",
				                border: selected ? "1px solid #7fb7ea" : "1px solid #dfe3e8",
				                display: "grid",
				                gridTemplateColumns: "1fr 34px",
				                alignItems: "center",
				                cursor: "pointer",
				                transition: "all 0.25s ease",
				                boxShadow: selected
				                    ? "0 4px 14px rgba(90,155,214,0.35)"
				                    : "0 2px 10px rgba(0,0,0,0.06)",
				                padding: "0 8px",
								width:'80px'
				            }}
				        >

				            {/* LEFT: DAY + TOTAL */}
				            <div
				                style={{
				                    display: "flex",
				                    flexDirection: "column",
				                    alignItems: "center",
				                    justifyContent: "center"
				                }}
				            >
				                <div
				                    style={{
				                        fontSize: "10px",
				                        fontWeight: "700",
				                        color: selected ? "#ffffff" : "#666",
				                        letterSpacing: "1px",
				                        marginBottom: "2px"
				                    }}
				                >
				                    {day.dayLabel}
				                </div>

				                <div
				                    style={{
				                        fontSize: "18px",
				                        fontWeight: "700",
				                        color: selected ? "#ffffff" : "#444",
				                        lineHeight: "18px"
				                    }}
				                >
				                    {day.bookingCount}
				                </div>
				            </div>

				            {/* RIGHT: GHOSTS ABOVE NO SHOWS */}
				            <div
				                style={{
				                    display: "flex",
				                    flexDirection: "column",
				                    gap: "4px",
				                    alignItems: "flex-end",
				                    justifyContent: "center"
				                }}
				            >
				                <div
				                    style={{
				                        background: "#a855f7",
				                        color: "#fff",
				                        borderRadius: "4px",
				                        fontSize: "9px",
				                        padding: "2px 5px",
				                        fontWeight: "700",
				                        lineHeight: "11px",
				                        minWidth: "24px",
				                        textAlign: "center"
				                    }}
				                >
				                    {day.ghosts || 0}
				                </div>

				                <div
				                    style={{
				                        background: "#f97316",
				                        color: "#fff",
				                        borderRadius: "4px",
				                        fontSize: "9px",
				                        padding: "2px 5px",
				                        fontWeight: "700",
				                        lineHeight: "11px",
				                        minWidth: "24px",
				                        textAlign: "center"
				                    }}
				                >
				                    {day.noShows || 0}
				                </div>
				            </div>

				        </div>
				    );
				})}

                </div>

            </div>

            {/* ------------------------------------------------ */}
            {/* SUB HEADER */}
            {/* ------------------------------------------------ */}

            <div
                style={{
                    padding: "16px 24px",
                    borderBottom:
                        "1px solid rgba(255,255,255,0.06)",
                    flexShrink: 0
                }}
            >

                <div
                    style={{
                        fontSize: "24px",
                        fontWeight: "700",
                        color: "#444",
                        lineHeight: "24px"
                    }}
                >
                    {filteredBookings.length} BOOKINGS
                </div>

                <div
                    style={{
                        fontSize: "12px",
                        color: "#999",
                        marginTop: "5px"
                    }}
                >
                    Daily booking overview
                </div>

            </div>

            {/* ------------------------------------------------ */}
            {/* GRID */}
            {/* ------------------------------------------------ */}

            <div
                style={{
                    flex: 1,
                    overflowY: "auto",
                    padding: "20px"
                }}
            >

                {filteredBookings.length === 0 && (

                    <div
                        style={{
                            width: "100%",
                            textAlign: "center",
                            color: "#777",
                            paddingTop: "120px",
                            fontSize: "18px"
                        }}
                    >
                        No bookings for selected day
                    </div>
                )}

                <div
                    style={{

                        display: "grid",

                        gridTemplateColumns:
                            "1fr 1fr",

                        gap: "16px",

                        alignItems: "start"
                    }}
                >

                    {filteredBookings.map(function (booking, index) {

                        return (

                            <RoomBookingCard
                                key={index}
                                booking={booking}
								workplaceActivities={props.workplaceActivities}
                            />
                        );

                    })}

                </div>

            </div>

            {/* ------------------------------------------------ */}
            {/* CLOSE BUTTON */}
            {/* ------------------------------------------------ */}

			<div
			    style={closeCircle}

			    onClick={function () {

			        props.onClose();
			    }}

			    onMouseEnter={function (e) {

			        e.currentTarget.style.background =
			            "#ffffff";

			        e.currentTarget.style.color =
			            "#222";

			        e.currentTarget.style.boxShadow =
			            "0 6px 18px rgba(0,0,0,0.18)";

			        e.currentTarget.style.border =
			            "1px solid #d6dbe1";

			        e.currentTarget.style.transform =
			            "translateY(-50%) scale(1.08)";
			    }}

			    onMouseLeave={function (e) {

			        e.currentTarget.style.background =
			            "#f4f6f8";

			        e.currentTarget.style.color =
			            "#666";

			        e.currentTarget.style.boxShadow =
			            "0 4px 12px rgba(0,0,0,0.1)";

			        e.currentTarget.style.border =
			            "1px solid rgba(255,255,255,0.08)";

			        e.currentTarget.style.transform =
			            "translateY(-50%) scale(1)";
			    }}
			>
			    <FontAwesomeIcon icon={faTimes} />
			</div>

        </div>
    );
}